import { useField } from '@adflow/frontend/util-common';

import type { InputTextFieldLengthProps } from './InputTextFieldLength';
import { InputTextFieldLength } from './InputTextFieldLength';

export type InputTextFieldLengthWithControlProps = {
	name: string;
	errorMessage?: string;
} & InputTextFieldLengthProps;

/**
 * Input with helper text displaying current length of the input value.
 * Sets error when length is past the max length
 * NOTE: String max length must also be set on form schema
 */
export function InputTextFieldLengthWithControl(
	props: InputTextFieldLengthWithControlProps
) {
	const { name, errorMessage: overrideErrorMessage, ...other } = props;

	const {
		field: { ref, ...inputProps },
		fieldState: { invalid: error },
		errorMessage,
	} = useField({ name, maxLength: other.maxLength });

	return (
		<InputTextFieldLength
			{...inputProps}
			inputRef={ref}
			error={error}
			helperText={overrideErrorMessage ?? errorMessage}
			{...other}
		/>
	);
}
